var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfessionalismTimeliness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_8193504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.86 22.856C45.1715 22.856 50.288 17.7395 50.288 11.428C50.288 5.11649 45.1715 0 38.86 0C32.5485 0 27.432 5.11649 27.432 11.428C27.432 17.7395 32.5485 22.856 38.86 22.856Z",
    fill: "url(#paint0_linear_29_23134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6018 30.4229L4.5732 34.5373V50.9715C4.50882 52.8285 4.90123 54.6729 5.716 56.3429C8.5732 62.0115 15.7732 63.6343 17.6018 63.9772C19.4076 63.6343 26.6076 62.0115 29.4646 56.3429C30.2723 54.6948 30.6647 52.8743 30.6076 51.0399V34.5373L17.6018 30.4229ZM27.18 43.1315L18.2646 52.0229C18.056 52.2397 17.8057 52.4122 17.5288 52.5301C17.2519 52.6479 16.9541 52.7087 16.6532 52.7087C16.3523 52.7087 16.0545 52.6479 15.7776 52.5301C15.5007 52.4122 15.2504 52.2397 15.0418 52.0229L10.3104 47.3145C10.0985 47.103 9.93032 46.8518 9.8156 46.5753C9.70087 46.2988 9.64182 46.0023 9.64182 45.703C9.64182 45.4036 9.70087 45.1071 9.8156 44.8306C9.93032 44.5541 10.0985 44.3029 10.3104 44.0915C10.7419 43.6632 11.3252 43.4229 11.9332 43.4229C12.5412 43.4229 13.1245 43.6632 13.556 44.0915L16.6646 47.1773L23.9332 39.9085C24.3648 39.4803 24.9481 39.24 25.5561 39.24C26.1641 39.24 26.7474 39.4803 27.179 39.9085C27.391 40.1198 27.5592 40.371 27.674 40.6475C27.7888 40.9239 27.848 41.2204 27.8481 41.5197C27.8482 41.8191 27.7892 42.1156 27.6746 42.3921C27.5599 42.6687 27.3919 42.9199 27.18 43.1315Z",
    fill: "url(#paint1_linear_29_23134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.4304 64.0001H52.5732V43.4287C52.576 43.1267 52.519 42.8272 52.4054 42.5474C52.2918 42.2676 52.1239 42.0131 51.9113 41.7986C51.6988 41.5841 51.4459 41.4138 51.1672 41.2976C50.8885 41.1814 50.5895 41.1215 50.2875 41.1215C49.9855 41.1215 49.6865 41.1814 49.4078 41.2976C49.1291 41.4138 48.8762 41.5841 48.6637 41.7986C48.4511 42.0131 48.2832 42.2676 48.1696 42.5474C48.056 42.8272 47.999 43.1267 48.0018 43.4287V64.0001H29.716V63.2801C31.2987 61.9127 32.5997 60.25 33.5464 58.3849V58.3825C34.6959 56.0885 35.2573 53.5448 35.18 50.9801V32.8573C35.1805 32.3716 35.026 31.8984 34.739 31.5065C34.4519 31.1147 34.0473 30.8247 33.584 30.6787L29.069 29.2513C31.5931 28.0548 34.3509 27.4323 37.1442 27.4287H40.5728C45.5722 27.4347 50.3651 29.4234 53.9002 32.9585C57.4353 36.4936 59.424 41.2865 59.43 46.2859L59.4304 64.0001Z",
    fill: "url(#paint2_linear_29_23134)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_23134",
    x1: 50.288,
    y1: -11.428,
    x2: 27.432,
    y2: -11.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_23134",
    x1: 30.613,
    y1: 13.6457,
    x2: 4.56638,
    y2: 13.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_23134",
    x1: 59.4304,
    y1: 9.14301,
    x2: 29.069,
    y2: 9.14301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalismTimeliness);
export default __webpack_public_path__ + "static/media/professionalism-timeliness.f0db70d5d1e220c02c011e6fb741339c.svg";
export { ForwardRef as ReactComponent };